import Image from "next/image";

function HowWorksCard({ imageSrc, title, description }) {
  return (
    <div className="max-w-[15.875rem] flex flex-col justify-center items-center text-center text-pet-tag">
      <div className="flex justify-center items-center mb-[1.25rem] w-[190px] h-[190px]">
        <Image
          src={imageSrc}
          width={190}
          height={190}
          alt={title}
          quality={30}
        />
      </div>

      <h3 className="text-[1.25rem] font-extrabold mb-[1rem]">{title}</h3>
      <p className="leading-[25.6px] text-center">{description}</p>
    </div>
  );
}

export default HowWorksCard;
